import type {
  EnhancedManCodeId,
  EnhancedProductFamilyId,
  EnhancedProductGroupId,
  EnhancedProductVariantId,
} from '#api/enhancements/enhancedTmsApiTypes.ts'
import type { FavoriteSetId } from '#features/FavoriteSets/FavoriteSet'
import { isStoredUserData, type StoredUserData, type UserDataVersion } from '#features/UserData/StoredUserData'
import type { TruckConfiguration } from '#store/slices/configurationSlice'

export type FavoriteEntry_0_2_0 = {
  id: EnhancedProductFamilyId | EnhancedProductGroupId | `${EnhancedProductFamilyId}${EnhancedProductVariantId}`
  createdAt: Timestamp
}

export type FavoriteSet_0_2_0 = {
  id: FavoriteSetId
  name: string
  createdAt: Timestamp
  entries: FavoriteEntry_0_2_0[]
}

export interface FavoritesData_0_2_0 {
  favoriteSets: FavoriteSet_0_2_0[]
}

export interface RecentManCodesData_0_2_0 {
  manCodes: {
    manCode: EnhancedManCodeId
    partPeriod?: TruckConfiguration['apiConfiguration']['partPeriod']
    deliveryDate?: TruckConfiguration['apiConfiguration']['desiredDealerDate']
    /** @deprecated use createdAt and lastUsedAt instead */
    timestamp?: Timestamp
    createdAt?: Timestamp
    lastUsedAt?: Timestamp
    marketDenomination?: TruckConfiguration['marketDenomination']
    title?: TruckConfiguration['title']
  }[]
}

export interface UserData_0_2_0 {
  favorites: FavoritesData_0_2_0
  recentManCodes: RecentManCodesData_0_2_0
}

export const userDataVersionNumber_0_2_0 = 'v0.2.0' as UserDataVersion<'v0.2.0'>
export type StoredUserData_0_2_0 = StoredUserData<UserData_0_2_0, typeof userDataVersionNumber_0_2_0>

export function isStoredUserData_0_2_0(storedData: unknown): storedData is StoredUserData_0_2_0 {
  return isStoredUserData(storedData) && storedData.__version === userDataVersionNumber_0_2_0
}
